var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#finance_svg__clip0_61530_7220)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 21h-21v1.5h21V21zM20.25 8.25A.75.75 0 0021 7.5V5.25a.75.75 0 00-.495-.705l-8.25-3a.75.75 0 00-.51 0l-8.25 3A.75.75 0 003 5.25V7.5a.75.75 0 00.75.75h.75V18H3v1.5h18V18h-1.5V8.25h.75zM4.5 5.775l7.5-2.73 7.5 2.73v.975h-15v-.975zM13.5 18h-3V8.25h3V18zM6 8.25h3V18H6V8.25zM18 18h-3V8.25h3V18z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "finance_svg__clip0_61530_7220"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgFinance;